export default {
  "newPoll": "+ New poll",
  "backToList": "‹ Back to list",
  "pollManagement": "Poll management",
  "createPollsConfigureOptionsAndDesignPagesSignedInUsers": "Create polls, configure options and design pages. Signed-in users can vote and view results.",
  "searchPollName": "Search poll name",
  "search": "Search",
  "noPollDescription": "No poll description",
  "open": "Open",
  "settings": "Settings",
  "preview": "Preview",
  "records": "Records",
  "duplicate": "Duplicate",
  "delete": "Delete",
  "noPollsYetClickNewPollToCreateOne": "No polls yet. Click New poll to create one.",
  "pollLinkPreview": "Poll link preview",
  "scanTheQrCodeOrCopyTheLinkToOpen": "Scan the QR code or copy the link to open the poll. Sign in first on mobile.",
  "copyLink": "Copy link",
  "draft": "Draft",
  "published": "Published",
  "closed": "Closed",
  "linkCopied": "Link copied",
  "couldNotCopyPleaseCopyTheLinkManually": "Could not copy. Please copy the link manually.",
  "untitledPoll": "Untitled poll",
  "pollCreated": "Poll created",
  "deleteAndItsDirectoryPollsWithVotesCannotBeDeleted": "Delete “{p0}” and its directory? Polls with votes cannot be deleted.",
  "deletePoll": "Delete poll",
  "deleted": "Deleted",
  "enterPollName": "Enter poll name",
  "basicFields": "Basic fields",
  "image": "Image",
  "searchComponent": "Search component",
  "commonFields": "Common fields",
  "layoutComponents": "Layout components",
  "text": "Text",
  "backgroundImage": "Background image",
  "results": "Results",
  "spacer": "Spacer",
  "dragTheHandleAtTheTopLeftOfAComponent": "Drag the handle at the top left of a component to reorder it. The voting component is always retained.",
  "pollPageDesigner": "Poll page designer",
  "backgroundComponent": "Background component",
  "dragToRepositionTheBackgroundVertically": "Drag to reposition the background vertically",
  "dragToReorder": "Drag to reorder",
  "visibilityRule": "Visibility rule:",
  "fixedVotingComponent": "Fixed voting component ·",
  "cannotBeDeleted": "· Cannot be deleted",
  "singleChoiceVoting": "Single-choice voting",
  "multipleChoiceVoting": "Multiple-choice voting",
  "multipleChoice": "Multiple choice",
  "singleChoice": "Single choice",
  "imageComponent": "Image component",
  "uploadAnImageInThePropertiesPanel": "Upload an image in the properties panel",
  "searchByIdOrName": "Search by ID or name",
  "votingOptions": "Voting options",
  "totalVoters": "Total voters",
  "leaderboard": "Leaderboard",
  "dragHereToDelete": "▱ Drag here to delete",
  "componentSettings": "Component settings",
  "fixed": "(Fixed)",
  "pollTitle": "Poll title",
  "votingMode": "Voting mode",
  "allowMultipleSelections": "Allow multiple selections",
  "maximumSelections": "Maximum selections",
  "newOption": "New option",
  "addOption": "+ Add option",
  "theVotingComponentCannotBeDeletedOptionsCannotBeChanged": "The voting component cannot be deleted. Options cannot be changed after votes are recorded.",
  "title": "Title",
  "required": "Required",
  "placeholder": "Placeholder",
  "descriptionContent": "Description content",
  "options": "Options",
  "optionName": "Option name",
  "value": "Value",
  "imageUrl": "Image URL",
  "uploadImage": "Upload image",
  "width": "Width (%)",
  "position": "Position",
  "left": "Left",
  "center": "Center",
  "right": "Right",
  "cornerRadiusPx": "Corner radius (px)",
  "textContent": "Text content",
  "textColor": "Text color",
  "fontSizePx": "Font size (px)",
  "fontWeight": "Font weight",
  "regular": "Regular",
  "bold": "Bold",
  "extraBold": "Extra bold",
  "textAlignment": "Text alignment",
  "leftMarginPx": "Left margin (px)",
  "rightMarginPx": "Right margin (px)",
  "topPaddingPx": "Top padding (px)",
  "bottomPaddingPx": "Bottom padding (px)",
  "bottomMarginPx": "Bottom margin (px)",
  "backgroundColor": "Background color",
  "backgroundImageUrl": "Background image URL",
  "uploadBackground": "Upload background",
  "clearBackground": "Clear background",
  "heightPx": "Height (px)",
  "opacity": "Opacity (%)",
  "topOffsetPx": "Top offset (px)",
  "spacerHeightPx": "Spacer height (px)",
  "searchTitle": "Search title",
  "leaderboardLabel": "Leaderboard label",
  "numberOfRankings": "Number of rankings",
  "backButtonPosition": "Back button position",
  "topLeft": "Top left",
  "bottomOfPage": "Bottom of page",
  "displaysOptionAndVoterCountsWithALinkToThe": "Displays option and voter counts, with a link to the leaderboard.",
  "visibilityRules": "Visibility rules",
  "none": "None",
  "enabled": "Enabled",
  "sourceField": "Source field",
  "selectAVoteRadioDropdownOrCheckboxField": "Select a vote, radio, dropdown or checkbox field",
  "selectAnOption": "Select an option",
  "addAVoteRadioDropdownOrCheckboxComponentFirst": "Add a vote, radio, dropdown or checkbox component first.",
  "selectAComponentFirst": "Select a component first",
  "pageSettings": "Page settings",
  "titleColor": "Title color",
  "titleFontSizePx": "Title font size (px)",
  "titleAlignment": "Title alignment",
  "submitButtonColor": "Submit button color",
  "submitButtonTextColor": "Submit button text color",
  "submitButtonWidth": "Submit button width (%)",
  "pageBackgroundColor": "Page background color",
  "enterImageUrl": "Enter image URL",
  "pollSettings": "Poll settings",
  "pollName": "Poll name",
  "publicationStatus": "Publication status",
  "startTimeOptional": "Start time (optional)",
  "noStartTimeLimit": "No start time limit",
  "endTimeOptional": "End time (optional)",
  "noEndTimeLimit": "No end time limit",
  "allSignedInUsersMayVoteOncePerAccountThe": "All signed-in users may vote once per account. The search component only looks up directory information and does not restrict eligibility.",
  "wechatSharing": "💬 WeChat sharing",
  "configureTheTitleSubtitleAndCoverForWechatSharingCards": "Configure the title, subtitle and cover for WeChat sharing cards. Leave the title blank to use the poll name.",
  "shareTitle": "Share title",
  "optionalDefaultsToThePollName": "Optional; defaults to the poll name",
  "subtitle": "Subtitle",
  "optionalDisplayedBelowTheTitle": "Optional; displayed below the title",
  "shareImage": "Share image",
  "recommended500500PxJpgPngUpTo5Mb": "Recommended: 500×500 px, JPG / PNG, up to 5 MB",
  "uploading": "Uploading…",
  "uploadShareCover": "Upload share cover",
  "clearShareImage": "Clear share image",
  "save": "Save",
  "publish": "Publish",
  "couldNotLoadPoll": "Could not load poll",
  "retry": "Retry",
  "edit": "Edit",
  "votingRecords": "Voting records",
  "singleLineText": "Single-line text",
  "multilineText": "Multiline text",
  "radioButtons": "Radio buttons",
  "dropdown": "Dropdown",
  "checkboxes": "Checkboxes",
  "number": "Number",
  "date": "Date",
  "divider": "Divider",
  "description": "Description",
  "name": "Name",
  "phoneNumber": "Phone number",
  "gender": "Gender",
  "email": "Email",
  "yesNo": "Yes / No",
  "wechatId": "WeChat ID",
  "idNumber": "ID number",
  "dateOfBirth": "Date of birth",
  "address": "Address",
  "votingComponent": "Voting component",
  "component": "Component",
  "chooseAnOption": "Choose an option",
  "for": "For",
  "against": "Against",
  "abstain": "Abstain",
  "aPageSupportsUpTo50Components": "A page supports up to 50 components",
  "onlyOneSearchComponentIsAllowedPerPage": "Only one search component is allowed per page",
  "onlyOneResultsComponentIsAllowedPerPage": "Only one results component is allowed per page",
  "enterText": "Enter text",
  "directorySearch": "Directory search",
  "option": "Option {p0}",
  "pollSaved": "Poll saved",
  "pollPublished": "Poll published",
  "imagesMustNotExceed5Mb": "Images must not exceed 5 MB",
  "youHaveUnsavedChangesLeaveThisPage": "You have unsaved changes. Leave this page?",
  "notice": "Notice",
  "searchVoterInformation": "Search voter information",
  "pollOptions": "Poll options",
  "reset": "Reset",
  "export": "Export",
  "copyPollLink": "Copy poll link",
  "refresh": "Refresh",
  "noVotingRecordsYetVotesFromSignedInUsersWill": "No voting records yet. Votes from signed-in users will appear here.",
  "voter": "Voter",
  "selectedOptions": "Selected options",
  "votedAt": "Voted at",
  "voted": "Voted",
  "noVotingRecordsMatchTheCurrentFilters": "No voting records match the current filters",
  "exportedVotingRecords": "Exported {p0} voting records",
  "couldNotExportVotingRecordsPleaseTryAgainLater": "Could not export voting records. Please try again later.",
  "requiredColumnsIdAndNameOtherColumnsAreCustomizableAnd": "Required columns: ID and the Name column from the downloaded template. Other columns are customizable and appear in search results. The directory does not restrict voting eligibility.",
  "noDirectoryUploaded": "No directory uploaded",
  "downloadTemplate": "Download template",
  "replaceFile": "Replace file",
  "uploadFile": "Upload file",
  "deleteFile": "Delete file",
  "supportsXlsxXlsAndCsvFirstSheetUpTo5": "Supports XLSX, XLS and CSV (first sheet), up to 5 MB / 5,000 rows. Uploads and deletions take effect immediately and do not remove votes.",
  "directoryPreview": "Directory preview",
  "confirmingReplacesTheEntireDirectoryExistingVotesAreUnaffected": "Confirming replaces the entire directory. Existing votes are unaffected.",
  "cancel": "Cancel",
  "confirmReplacement": "Confirm replacement",
  "confirmUpload": "Confirm upload",
  "directory": "Directory",
  "pollDirectoryTemplateXlsx": "Poll_directory_template.xlsx",
  "filesMustNotExceed5Mb": "Files must not exceed 5 MB",
  "upTo5000RowsAnd30ColumnsPerFile": "Up to 5,000 rows and 30 columns per file",
  "includeIdAndNameColumnsHeadersMustBeNonEmpty": "Keep the ID and Name column headers from the downloaded template. Headers must be non-empty and unique.",
  "headersContainReservedNames": "Headers contain reserved names",
  "rowMissingOverlongOrDuplicateIdOrInvalidName": "Row {p0}: missing, overlong or duplicate ID, or invalid name",
  "rowACellExceeds1000Characters": "Row {p0}: a cell exceeds 1,000 characters",
  "noDirectoryEntriesFound": "No directory entries found",
  "couldNotReadTheFile": "Could not read the file",
  "importedDirectoryEntries": "Imported {p0} directory entries",
  "deleteTheCurrentDirectoryAndSearchDataExistingVotesWill": "Delete the current directory and search data? Existing votes will be retained.",
  "deleteDirectory": "Delete directory",
  "directoryDeleted": "Directory deleted",
  "lastSaved": "Last saved:",
  "updated": "Updated",
  "votingOptions2": "{p0} voting options",
  "peopleHaveVoted": "{p0} people have voted",
  "entries": "{p0} entries",
  "rowsColumnsFirst10RowsShown": "{p0} · {p1} rows / {p2} columns (first 10 rows shown)",
  "voters": "voters",
  "pollOptions2": "Poll options ({p0})",
  "resultsComponent": "Results component",
  "enterField": "Enter {label}",
  "validField": "Enter a valid {label}",
  "male": "Male",
  "female": "Female",
  "other": "Other",
  "yes": "Yes",
  "no": "No",
  "recordsFilename": "Voting_records_{stamp}.xlsx",
  "query": "Search",
  "recordSheetName": "Voting records"
}
